import React from 'react'
import Button from '@vero/ui-components/components/button.jsx'

export default function ({ title = 'submit', loading = false, disabled = false, children, ...props }) {
  return (
    <Button type='submit' className='btn-primary drop-shadow uppercase' loading={loading} disabled={loading} {...props}>
      {loading ? 'loading' : title}
      {children}
    </Button>
  )
}
